/// <amd-module name="Build/Admin/Pool/Components/PoolAnalytics" />
import { AnalyticsExtensionValidator } from "Analytics/Shared/Common/AnalyticsExtensionValidator";
import { PoolGraph } from "Build/Admin/Pool/Components/PoolGraph";
import * as Resources from "Build/Admin/Pool/Resources";
import { StoresHub } from "Build/Admin/Pool/Stores/StoresHub";
import * as React from "react";
import { IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { PoolGraphActionsCreator } from "../Actions/PoolGraphActionCreator";

export interface IPoolProps extends IVssComponentProperties {
    actionCreator: PoolGraphActionsCreator;
    storesHub: StoresHub;
}

export class PoolAnalytics extends VssComponent<IPoolProps> {
    public render() {
        return <AnalyticsExtensionValidator>{this._renderComponent()}</AnalyticsExtensionValidator>;
    }

    private _renderComponent(): JSX.Element {
        const childComponentProperties = {
            actionCreator: this.props.actionCreator,
            contextType: "build",
            headerTitle: Resources.PoolConsumptionReport,
            storesHub: this.props.storesHub
        };

        return <PoolGraph {...childComponentProperties}></PoolGraph>;
    }
}
